/* eslint-disable tailwindcss/no-custom-classname */
import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { ON_DEMAND, SAME_DAY } from '../../helpers/constants';
import { capitalizeFirstLetter } from '../../helpers/utils';
import { FSDBMMessage } from './FSDBMMessage';

const getDeliveryCharge = (option) => {
  if (option?.totalCharge) {
    return <span className="sui-text">${option?.totalCharge}</span>;
  }
  return option?.totalCharge === 0 ? <span className="sui-text-success">Free</span> : <span />;
};

const getTimelineText = (option, enableFSDBM, bodfsLatestDelivery) => {
  const type = option?.type;
  if (type === ON_DEMAND) {
    return `Within ${option?.timeline}`;
  }
  if (type === SAME_DAY) {
    const timeline = option?.timeline;
    const capitalizedTimeline = timeline?.toLowerCase() === 'today'
      ? capitalizeFirstLetter(timeline.toLowerCase())
      : timeline;
    const time = `by ${bodfsLatestDelivery}`;
    return `${capitalizedTimeline}* ${enableFSDBM ? time : ''}`;
  }
  return option?.timeline;
};

const PriorityOption = ({ option, enableFSDBM, bodfsLatestDelivery, children }) => {
  return (
    <div>
      <div className={!enableFSDBM ? "sui-pb-5" : "sui-border-t-1 sui-border-primary sui-border-solid sui-py-4"}>
        <Typography variant="body-lg" height="normal">
          <div className="sui-grid sui-grid-cols-12">
            <div className="sui-col-span-10 sui-pb-1">
              {'Get it '}
              <span className="sui-font-bold">{getTimelineText(option, enableFSDBM, bodfsLatestDelivery)}</span>
            </div>
            <div className="sui-col-span-2 sui-text-end sui-font-bold">
              {getDeliveryCharge(option)}
            </div>
          </div>
        </Typography>
        {children}
      </div>
    </div>
  );
};

export const PriorityDeliveryOptions = ({
  priorityDeliveryOptions = [],
  enableFSDBM = false,
  fsdbmThreshold,
  bodfsLatestDelivery
}) => {
  const onDemand = priorityDeliveryOptions?.find((option) => option?.type === ON_DEMAND);
  const sameDay = priorityDeliveryOptions?.find((option) => option?.type === SAME_DAY);

  return (
    <div data-testid="priority-delivery-options">
      {onDemand && <PriorityOption option={onDemand} enableFSDBM={enableFSDBM}/>}
      {
        sameDay && <PriorityOption option={sameDay} enableFSDBM={enableFSDBM} bodfsLatestDelivery={bodfsLatestDelivery}>
        {enableFSDBM &&
        <FSDBMMessage threshold={fsdbmThreshold} isFree={sameDay?.totalCharge === 0}/>}
        </PriorityOption>
      }
    </div>
  );
};